import TextMessage from './TextMessage';

export default TextMessage;
